import { Component, Input, OnInit } from '@angular/core';
import { ModalTabsData } from '../modal.component';

@Component({
  selector: 'fcp-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit {
  public _tabs: Array<ModalTabsData>;
  public selectedIndex = 0;
  public selectedCardIndex = null;

  @Input() public set tabs(value: Array<ModalTabsData>) {
    const tabs = value || [];
    this._tabs = tabs.sort((a, b) => {
      return a.group !== b.group ? 1 : 0;
    });
  }
  @Input() idTab: string;

  public get getTabs(): Array<ModalTabsData> {
    return this._tabs;
  }

  constructor() {}

  ngOnInit() {
    if (this.idTab) {
      this._tabs.forEach((item, i) => {
        if (this.idTab === item.id) this.selectedIndex = i;
      });
    }
  }

  public selectTab(index: number): void {
    this.selectedIndex = index;
  }

  public selectCard(index: number): void {
    this.selectedCardIndex = index;
  }

  public hasExtraInfo(card: any): any {
    return (card?.extraInfo && (card?.extraInfo)[0]) || false;
  }
}
